import { Component, inject } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import {
  AuthService,
  AUTH_INITIALIZATION_ERROR,
} from '@nimmsta/ng-commons-lib/auth';
import { LanguageService } from '@nimmsta/ng-commons-lib/services/language';
import { LoginErrorComponent } from '@nimmsta/ng-commons-lib/login-error';

@Component({
  standalone: true,
  imports: [RouterOutlet, LoginErrorComponent],
  selector: 'app-root',
  template: `
    @if (loginError() !== null) {
      <app-login-error />
    } @else {
      <router-outlet />
    }
  `,
})
export class AppComponent {
  protected readonly loginError = inject(AUTH_INITIALIZATION_ERROR);
  private readonly router = inject(Router);
  private languageService = inject(LanguageService);
  private authService = inject(AuthService);

  constructor() {
    if (this.loginError() !== null) {
      this.languageService.changeLanguage(
        this.languageService.getPreferredLanguage(),
      );
      return;
    }

    this.router.initialNavigation();
    this.authService.loadCurrentUser().subscribe({
      complete: () => {
        this.languageService.changeLanguage(
          this.languageService.getPreferredLanguage(),
        );
      },
      error: () => {
        this.languageService.changeLanguage(
          this.languageService.getPreferredLanguage(),
        );
      },
    });
  }
}
